export default __webpack_public_path__ + "static/media/chocolatemuffin.ccf0280a.png";